import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { PitchContext } from "../context/PitchContex";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AccessDenied from "../components/AccessDenied";

const Payment = () => {
  const { slug } = useParams();
  const {
    backendURL,
    setIsErr,
    user,
    token,
    setShowAlert,
    setAlertMessage,
    setPending,
    navigate,
    userNote,
    setUserNote,
    bookingData,
    pendingBookingID,
    setIsPaid,
  } = useContext(PitchContext);
  //asdas
  const [paymentType, setPaymentType] = useState("price");
  const [card, setCard] = useState({
    name: "John Doe",
    number: "5528790000000008",
    expireMonth: "12",
    expireYear: "2030",
    cvc: "123",
  });

  const [userInfo, setUserInfo] = useState({
    name: user.fullname.split(" ")[0] || "",
    surname: user.fullname.split(" ")[1] || "",
    identityNumber: "",
    address: "",
    city: "",
  });

  const [pitch, setPitch] = useState();

  const [timeLeft, setTimeLeft] = useState(300);

  // Countdown timer effect
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          executeAfterFiveMinutes();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    return () => {
      const storedIsPaid = localStorage.getItem("isPaid");
      if (storedIsPaid !== "true") {
        setUserNote("");
        executeAfterFiveMinutes();
      }
    };
  }, []);

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  // Function to execute after 5 minutes
  const executeAfterFiveMinutes = () => {
    setPending(true);
    axios
      .post(backendURL + "booking/remove", {
        userID: user._id,
        bookingID: JSON.parse(localStorage.getItem("bookingID")),
        pitchID: slug,
      })
      .then((_) => {
        setPending(false);
        localStorage.removeItem("bookingID");
        setIsErr(true);
        setShowAlert(true);
        setAlertMessage(
          "Ödemenizi tamamlamadığınız için rezervasyon işleminiz iptal edilmiştir."
        );
        navigate("/");
      })
      .catch((err) => {
        setPending(false);
        localStorage.removeItem("bookingID");
        console.log(err);
        console.log("Asd error");
      });
  };

  const getPitch = () => {
    setPending(true);
    axios
      .post(backendURL + `pitch/get/${slug}`)
      .then((response) => {
        if (response.data.success) {
          setPending(false);
          setPitch(response.data.pitch);
        }
      })
      .catch((err) => {
        setPending(false);
        console.log(err);
        toast.error(err.response.data.message);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getPitch();
  }, []);

  const handleUserInfoChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };

  const handleCardChange = (e) => {
    setCard({ ...card, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPending(true);

    const bookingDataCopy = structuredClone(bookingData);
    const paymentData = {
      user: {
        id: user._id,
        name: userInfo.name,
        surname: userInfo.surname,
        email: user.email,
        identityNumber: userInfo.identityNumber,
        address: userInfo.address,
        city: userInfo.city,
        phone: user.phone,
        userNote: userNote,
      },
      amount: paymentType === "price" ? pitch.price : pitch.deposit,
      card,
      pitch: {
        name: pitch.name,
        address: pitch.location.address,
        email: pitch.ownerID.email,
        owner: pitch.ownerID.fullname,
        subMerchantKey: pitch.ownerID.subMerchant.subMerchantKey,
      },
      bookingData: JSON.stringify(bookingDataCopy),
      bookingID: localStorage.getItem("bookingID"),
    };

    try {
      const response = await axios.post(
        backendURL + "payment/pay",
        paymentData
      );
      setUserNote("");
      if (response.data.success) {
        setIsPaid(true);
        localStorage.setItem("isPaid", "true");
        setAlertMessage("Ödeme başarıyla tamamlandı!");
        setIsErr(false);
        setShowAlert(true);
        navigate("/profil");
      } else {
        setAlertMessage(response.data.message);
        setIsErr(true);
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Ödeme Hatası:", error);
      setAlertMessage(error.response.data.message);
      setIsErr(true);
      setShowAlert(true);
    } finally {
      setPending(false);
    }
  };

  if (!token) {
    return <AccessDenied />;
  }
  // asdfasdasdsaasd
  if (!pitch) {
    return <div className="">loading</div>;
  }
  //asdasdasdsdasd
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 p-4">
      {/* Pitch Information - Full Width at Top */}
      <div className="w-full max-w-5xl mx-auto mb-8 bg-white rounded-2xl shadow-2xl p-8">
        <h2 className="text-3xl font-bold text-[#6ca87e] mb-6 tracking-tight">
          Saha Detayları
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* ... Pitch info remains the same ... */}
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
              Saha Adı
            </span>
            <p className="text-lg text-gray-800 font-medium">
              {pitch.name || "Seçilen Saha"}
            </p>
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
              Konum
            </span>
            <p className="text-lg text-gray-800 font-medium">
              {pitch.location.address || "İstanbul, Türkiye"}
            </p>
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
              Süre
            </span>
            <p className="text-lg text-gray-800 font-medium">1 Saat</p>
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
              Fiyat
            </span>
            <p className="text-3xl font-bold text-[#6ca87e]">
              {pitch.price?.toFixed(2) || "0.00"} TL
            </p>
            {pitch.deposit && (
              <div>
                <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                  Fiyat
                </span>
                <p className="text-3xl font-bold text-[#6ca87e]">
                  {pitch.deposit?.toFixed(2) || "0.00"} TL
                </p>
              </div>
            )}
            <p className="text-sm text-red-500 mt-2">
              Kalan Süre:{" "}
              <span className="font-semibold">{formatTime(timeLeft)}</span>
            </p>
          </div>
        </div>
      </div>

      {/* User Info and Payment Form Container */}
      <div className="flex flex-col md:flex-row w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Left Side - User Information with Inputs */}
        <div className="w-full md:w-1/2 p-8 bg-gray-50 border-r border-gray-200">
          <h2 className="text-2xl font-bold text-[#6ca87e] mb-6 tracking-tight">
            Kullanıcı Bilgileri
          </h2>
          <div className="space-y-5">
            <div>
              <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Ad
              </label>
              <input
                type="text"
                name="name"
                value={userInfo.name}
                onChange={handleUserInfoChange}
                required
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 text-gray-800"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Soyad
              </label>
              <input
                type="text"
                name="surname"
                value={userInfo.surname}
                onChange={handleUserInfoChange}
                required
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 text-gray-800"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Kimlik Numarası
              </label>
              <input
                type="text"
                name="identityNumber"
                value={userInfo.identityNumber}
                onChange={handleUserInfoChange}
                required
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 text-gray-800"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Adres
              </label>
              <input
                type="text"
                name="address"
                value={userInfo.address}
                onChange={handleUserInfoChange}
                required
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 text-gray-800"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Şehir
              </label>
              <input
                type="text"
                name="city"
                value={userInfo.city}
                onChange={handleUserInfoChange}
                required
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 text-gray-800"
              />
            </div>
          </div>
        </div>

        {/* Right Side - Payment Form */}
        <div className="w-full md:w-1/2 p-8">
          <h2 className="text-2xl font-bold text-[#6ca87e] text-center mb-6 tracking-tight">
            Ödemeyi Tamamla
          </h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* ... Payment form remains the same ... */}
            <div>
              <input
                type="text"
                name="name"
                placeholder="Kart Sahibinin Adı"
                value={card.name}
                onChange={handleCardChange}
                required
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 placeholder-gray-500 text-gray-800"
              />
            </div>
            <div>
              <input
                type="text"
                name="number"
                placeholder="Kart Numarası"
                value={card.number}
                onChange={handleCardChange}
                required
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 placeholder-gray-500 text-gray-800"
              />
            </div>
            <div className="flex space-x-4">
              <input
                type="text"
                name="expireMonth"
                placeholder="AA"
                value={card.expireMonth}
                onChange={handleCardChange}
                required
                className="w-1/2 px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 placeholder-gray-500 text-gray-800"
              />
              <input
                type="text"
                name="expireYear"
                placeholder="YYYY"
                value={card.expireYear}
                onChange={handleCardChange}
                required
                className="w-1/2 px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 placeholder-gray-500 text-gray-800"
              />
            </div>
            <div>
              <input
                type="text"
                name="cvc"
                placeholder="CVC"
                value={card.cvc}
                onChange={handleCardChange}
                required
                className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6ca87e] focus:border-transparent transition-all duration-200 placeholder-gray-500 text-gray-800"
              />
            </div>

            {pitch.deposit && (
              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                  Ödeme Türü Seçin
                </p>
                <div className="flex space-x-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="paymentType"
                      value="price"
                      checked={paymentType === "price"}
                      onChange={() => setPaymentType("price")}
                      className="text-[#6ca87e] focus:ring-[#6ca87e]"
                    />
                    <span className="text-gray-800">
                      Tam Ücret ({pitch.price?.toFixed(2)} TL)
                    </span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="paymentType"
                      value="deposit"
                      checked={paymentType === "deposit"}
                      onChange={() => setPaymentType("deposit")}
                      className="text-[#6ca87e] focus:ring-[#6ca87e]"
                    />
                    <span className="text-gray-800">
                      Depozito ({pitch.deposit?.toFixed(2)} TL)
                    </span>
                  </label>
                </div>
              </div>
            )}

            <button
              type="submit"
              className={`w-full px-4 py-3 text-white font-semibold rounded-lg transition-all duration-300 ${"bg-[#6ca87e] hover:bg-[#5d8f6c] hover:shadow-lg transform hover:-translate-y-1 cursor-pointer"}`}
            >
              Şimdi Öde
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Payment;
